<template>
    <div>
        <v-row>
            <v-col cols="6">
                <h2 class="mb-5">VKU</h2>
                <v-data-table :hide-default-footer="true" :headers="header" :loading="loading" :items="vku" class="elevation-1" mobile-breakpoint="0">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td v-for="(c, i) in header" :key="i" style="padding:8px">
                                {{ item[c.value] }}
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
            <v-col cols="6">
                <h2 class="mb-5">PGS</h2>
                <v-data-table :hide-default-footer="true" :headers="header" :loading="loading" :items="pgs" class="elevation-1" mobile-breakpoint="0">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td v-for="(c, i) in header" :key="i" style="padding:8px">
                                {{ item[c.value] }}
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import ProductMixin from "@/mixins/Product";

export default {
    data: () => ({
        loading: false,
        header: [
            { text: "Name", value: "name", class: 'primary white--text', sortable: false },
            { text: "Date", value: "date", class: 'primary white--text', sortable: false }
        ],
        vku: [],
        pgs: []
    }),
    mixins: [ProductMixin],
    methods: {
        async fetchSection(sectionId) {
            const payload = {
                "section": sectionId,
                "language": "de",
            };

            const result = await this.action("get", payload);

            return result.map(g => ({
                name: g.name,
                date: g.date
            }));
        },
        async fetch() {
            this.loading = true;

            this.vku = [
                ...(await this.fetchSection("vku-zurich")),
                ...(await this.fetchSection("vku-lachen")),
            ];
            this.pgs = [
                ...(await this.fetchSection("pgs-zurich")),
                ...(await this.fetchSection("pgs-lachen")),
            ];

            this.loading = false;
        }
    }
}
</script>